module.exports = __webpack_public_path__ + "static/media/icon_service_07_pc.4fa33b9c.webp";